/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';


class StudentsService {

    test(fields , csv , header)
    {
        return ApplicationServices.call(Constants.TEST_STUDENT_IMPORT , {has_header_removed:header , fields:fields , csv:csv}).then(function(response){
            Action.update(Constants.TEST_STUDENT_IMPORT , response);
            return response;
        });
    };

    import(settings , fields , csv , header)
    {
        return ApplicationServices.call(Constants.INSERT_STUDENT_IMPORT , {has_header_removed:header , fields:fields , csv:csv}).then(function(response){
            Action.update(Constants.INSERT_STUDENT_IMPORT , response);
            return response;
        });
    };

    getExistingStudents(studentNames){
        return ApplicationServices.call(Constants.EXISITNG_ACCOUNT_STUDENTS , {students:studentNames}).then(function(response){
            Action.update(Constants.EXISITNG_ACCOUNT_STUDENTS , response);
            return response.existingStudents;
        });
    }


}

export default new StudentsService();